/* global smoothScroll, Ten4Slideshow, ajax, ScrollPatrol */
import { breakpoints } from '../variables.yml';

// framework libs
import './vendor/smoothscroll.min.js';
import './vendor/slideshow.min.js';
import Player from '@vimeo/player';
import './vendor/scroll-patrol.min.js';
import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';
import './vendor/ajax.min.js';

import EmblaCarousel from 'embla-carousel';
import Fade from 'embla-carousel-fade';
import AutoScroll from 'embla-carousel-auto-scroll';

import { getWindowHeight, getWindowWidth, addTogglePrevNextBtnsActive, addPrevNextBtnsClickHandlers, add_dot_btns_and_click_handlers } from './helpers.js';

export * from './CookieConsentManager.js';

function getOffsetTop( element ) {
	// Thanks to https://github.com/cferdinandi/smooth-scroll
	let offset = 0;
	if ( element.offsetParent ) {
		do {
			offset += element.offsetTop;
			element = element.offsetParent;
		} while ( element );
	}
	offset = Math.max( offset, 0 );
	return offset;
}

function isElementInViewport( element ) {
	const rect = element.getBoundingClientRect();
	return (
		rect.top <= ( window.innerHeight || document.documentElement.clientHeight ) + 170
	);
}

( () => {
	// Preload video embeds
	const video_embed = document.getElementById( 'main-media' );

	if ( video_embed ) {
		handleVideoPreload( video_embed );
	}

	function handleVideoPreload( video_embed ) {
		const wrapper = video_embed.querySelector( '.flex-container' );
		if ( !wrapper ) {
			return;
		}
		const poster = video_embed.querySelector( '.header-media__poster' );
		// const pause = video_embed.querySelector( '.hero__control--pause' );
		const iframe = wrapper.querySelector( 'iframe' );
		const player = new Player( iframe );
		player.addCuePoint( 0.10 );
		player.on( 'cuepoint', () => {
			poster.classList.add( 'faded' );
		} );
	}

} )();

( () => {
	// Preload homepage video
	const video_embed = document.querySelector( '.hero__video' );
	if ( !video_embed ) {
		return;
	}

	handleVideoPreload( video_embed );

	function handleVideoPreload( video_embed ) {
		const poster = video_embed.querySelector( '.header-media__poster' );
		const video = video_embed.querySelector( 'video' );
		video.addEventListener( 'canplay', () => {
			poster.classList.add( 'faded' );
		} );
		window.addEventListener( 'click', ( e ) => {
			if ( !e.target.classList.contains( 'hero__control--pause' ) ) {
				return;
			}
			if ( video.paused ) {
				video.play();
				e.target.classList.remove( 'paused' );
				return;
			}
			e.target.classList.add( 'paused' );
			video.pause();
		} );
	}

} )();

( () => {
	// Preload autoplay video content blocks (an entry can contain more than one)
	const video_blocks = document.querySelectorAll( '.video-autoplay' );

	video_blocks.forEach( ( video_block ) => {
		const poster = video_block.querySelector( '.video-autoplay__poster' );
		const video = video_block.querySelector( 'video' );
		if ( !poster || !video ) {
			return;
		}
		video.addEventListener( 'canplay', () => {
			poster.classList.add( 'faded' );
		} );
	} );

} )();

( function() {
	// Insight filters
	window.addEventListener( 'click', ( e ) => {
		if ( !e.target.classList.contains( 'insight-filters__toggle' ) ) {
			return;
		}
		document.body.classList.toggle( 'insight-filters-open' );
	} );
} )();

( function() {
	// Authors pop up
	const authors = document.querySelectorAll( '.insight-listing__author--inline' );
	if ( authors.length === 0 ) {
		return;
	}
	for ( let i = 0; i < authors.length; i++ ) {
		authors[i].addEventListener( 'click', ( e ) => {
			e.preventDefault();
			handleAuthorOverlayToggle();
		} );
	}

	window.addEventListener( 'click', ( e ) => {
		if ( !e.target.classList.contains( 'insight-author-overlay__close' ) ) {
			return;
		}
		const overlay = document.querySelector( '.insight-author-overlay--active' );
		if ( !overlay ) {
			return;
		}
		overlay.classList.remove( 'insight-author-overlay--active' );
	} );

	function handleAuthorOverlayToggle() {
		const overlay = document.querySelector( '.insight-author-overlay' );
		if ( !overlay ) {
			return;
		}
		overlay.classList.toggle( 'insight-author-overlay--active' );
	}

} )();

( function() {
	// Filter bar toggles
	const filter_toggles = document.querySelectorAll( '.filter-toggle' );
	const filter_block = document.querySelector( '.filter-section' );

	if ( !filter_toggles || !filter_block ) {
		return;
	}

	window.addEventListener( 'click', ( e ) => {
		handleFilterToggle( e );
	} );


	function handleFilterToggle( e ) {
		if ( e.target.classList.contains( 'filter-toggle' ) ) {
			if ( filter_block.classList.contains( 'visible' ) ) {
				filter_block.classList.remove( 'visible' );
				document.body.classList.remove( 'filter-open' );
			} else {
				document.body.classList.add( 'filter-open' );
				filter_block.classList.add( 'visible' );
			}
		}
	}

} )();

( function() { // Search
	const menu_button = document.querySelector( '.nav__control--menu' );
	const search_button = document.querySelector( '.nav__control--search' );
	const search_input = document.getElementById( 'js-search-input' );

	if ( !search_button || !search_input ) {
		return;
	}

	function closeNavIfOpen() {
		if ( !menu_button ) {
			return;
		}

		if ( menu_button.classList.contains( 'toggler--toggled' ) ) {
			const toggle_selector = menu_button.getAttribute( 'data-togglees' );
			if ( toggle_selector ) {
				document.querySelectorAll( toggle_selector ).forEach( el => el.classList.remove( 'toggled' ) );
			}

			menu_button.classList.remove( 'toggler--toggled' );
		}
	}


	search_button.addEventListener( 'click', ( event ) => {
		event.preventDefault ? event.preventDefault() : event.returnValue = false;

		closeNavIfOpen();

		document.body.classList.toggle( 'search-open' );

		window.setTimeout( () => {
			search_input.focus();
		}, 500 );
	} );

	if ( menu_button ) {
		menu_button.addEventListener( 'click', () => {
			if ( document.body.classList.contains( 'search-open' ) ) {
				document.body.classList.remove( 'search-open' );
			}
		} );
	}

	document.querySelector( '.search__wrapper' ).addEventListener( 'click', ( event ) => {
		const target = event.target || event.srcElement;
		const id = target.id;

		if ( id !== 'js-search-input' ) {
			document.body.classList.remove( 'search-open' );
		}
	} );

	window.addEventListener( 'keyup', ( e ) => {
		if ( e.keyCode === 27 ) {
			document.body.classList.remove( 'search-open' );
		}
	} );

} )();

( () => {
	function doToggle( toggler ) {
		const togglees = document.querySelectorAll( toggler.getAttribute( 'data-togglees' ) );
		for ( let i = 0; i < togglees.length; i += 1 ) {
			togglees[i].classList.toggle( 'toggled', !togglees[i].classList.contains( 'toggled' ) );
		}
		toggler.classList.toggle( 'toggler--toggled', !toggler.classList.contains( 'toggler--toggled' ) );
	}

	window.addEventListener( 'click', ( event ) => {
		if ( !event.target.classList.contains( 'toggler' ) ) {
			return;
		}
		doToggle( event.target );
	} );
} )();

( () => {
	// Accordion
	const accordion_groups = document.querySelectorAll( '.js-accordion-group' );
	if ( !accordion_groups ) {
		return;
	}

	const accordion_items_on_page = document.querySelectorAll( '.js-accordion' );

	window.addEventListener( 'click', ( e ) => {
		const accordion_toggle = e.target.closest( '.js-accordion-toggle' );
		if ( !accordion_toggle ) {
			return;
		}

		if ( accordion_toggle.classList.contains( 'active' ) ) {
			closeAllPanels( accordion_toggle );
			return;
		}
		closeAllPanels( accordion_toggle );
		accordion_toggle.classList.add( 'active' );
		accordion_toggle.setAttribute( 'aria-expanded', true );

		const panel = accordion_toggle.closest( '.js-accordion' ).querySelector( '.js-accordion-content' );
		panel.classList.add( 'open' );
	} );


	window.addEventListener( 'resize', () => {
		for ( let i = 0; i < accordion_items_on_page.length; i += 1 ) {
			const breakpoint = accordion_items_on_page[i].getAttribute( 'data-breakpoint' );
			const panel = accordion_items_on_page[i].querySelector( '.js-accordion-content' );

			if ( breakpoint && getWindowWidth() > breakpoints[breakpoint].width ) {
				panel.classList.add( 'open' );
			} else if ( breakpoint && getWindowWidth() < breakpoints[breakpoint].width ) {
				panel.classList.remove( 'open' );
			}

		}
	} );

	function closeAllPanels( item ) {
		const accordion_group = item.closest( '.js-accordion-group' );
		const accordion_toggles = accordion_group.querySelectorAll( '.js-accordion-toggle' );
		for ( let i = 0; i < accordion_toggles.length; i += 1 ) {
			const toggle = accordion_toggles[i];
			const panel = toggle.closest( '.js-accordion' ).querySelector( '.js-accordion-content' );
			panel.classList.remove( 'open' );
			toggle.classList.remove( 'active' );
			toggle.setAttribute( 'aria-expanded', false );
		}
	}
} )();

( () => {
	// Keep the accordion-with-image toggle button vertically centred against the image (desktop)
	// or the heading (mobile), independent of the panel's (variable) height.
	const rows = document.querySelectorAll( '.accordion-image__row' );
	if ( !rows.length ) {
		return;
	}

	function positionButtons() {
		rows.forEach( ( row ) => {
			const media = row.querySelector( '.accordion-image__media' );
			const heading = row.querySelector( '.accordion-image__heading' );
			if ( media ) {
				row.style.setProperty( '--accordion-image-icon-top', ( media.offsetHeight / 2 ) + 'px' );
			}
			if ( heading ) {
				row.style.setProperty( '--accordion-image-icon-top-mobile', ( heading.offsetHeight / 2 ) + 'px' );
			}
		} );
	}

	positionButtons();
	window.addEventListener( 'load', positionButtons );
	window.addEventListener( 'resize', positionButtons );
} )();

( function() {
	// Masonry Grid
	function createMasonry( element ) {
		return function() {
			return new Masonry( element, {
				itemSelector: '.masonry__brick',
				transitionDuration: 0
			} );
		};
	}
	const masonry_containers = document.querySelectorAll( '.masonry' );
	for ( let i = 0; i < masonry_containers.length; i += 1 ) {
		const img_load = imagesLoaded( masonry_containers[i] );
		const msnry = createMasonry( masonry_containers[i] )();
		img_load.on( 'progress', ( function( masonry ) {
			return function() {
				masonry.layout();
			};
		} )( msnry ) );
		img_load.on( 'always', ( function( element ) {
			return function() {
				element.classList.add( 'masonry--loaded' );
			};
		} )( masonry_containers[i] ) );
	}
} )();

( function() {
	// Fade in listing images
	const scroll_patrol = new ScrollPatrol( getWindowHeight() ); // offset in px
	const items = document.querySelectorAll( '.project-thumb, .masonry__brick, .fw, .header-media, .header-slideshow, .listing__image__inner' );

	imagesLoaded( document.body, () => {
		for ( let i = 0; i < items.length; i += 1 ) {
			if ( isElementInViewport( items[i] ) || items[i].classList.contains( '.header-media' ) ) {
				items[i].classList.remove( 'is-hidden' );
			}
			scroll_patrol.add( {
				element: items[i],
				enter: function( element ) {
					element.classList.remove( 'is-hidden' );
				}
			} );
		}
	} );

} )();

( function() {
	// Bind up mobile nav toggles
	if ( getWindowWidth() <= 1200 ) {
		const parent_nav_list_items = document.querySelectorAll( '.main-nav__has-child' );
		for ( let i = 0; i < parent_nav_list_items.length; i++ ) {
			const link = parent_nav_list_items[i].querySelector( 'a' );
			link.addEventListener( 'click', bindExpandNavItem( link ) );
		}
	}
	function bindExpandNavItem( link ) {
		return function( event ) {
			event.preventDefault();
			closeOtherItems( link );
			link.parentNode.classList.toggle( 'main-nav__has-child--open' );
		};
	}
	function closeOtherItems( link ) {
		const parent_nav_list_items = document.querySelectorAll( '.main-nav__has-child' );
		for ( let i = 0; i < parent_nav_list_items.length; i++ ) {
			if ( parent_nav_list_items[i].querySelector( 'a' ) !== link ) {
				parent_nav_list_items[i].classList.remove( 'main-nav__has-child--open' );
			}
		}
	}
} )();

( function() {
	// Accordions :(
	function Accordion( trigger, on_before_open ) {
		this.trigger = trigger;
		this.element = document.getElementById( trigger.getAttribute( 'data-accordion-id' ) );
		this.on_before_open = on_before_open;
		this.accordionContent = this.element.querySelector( '.accordion__item__inner' );
		this.accordionContentInner = this.element.querySelector( '.accordion__item__content' );
	}
	Accordion.prototype.isOpen = function() {
		return this.element.classList.contains( 'accordion__item--open' );
	};
	Accordion.prototype.toggle = function() {
		if ( this.isOpen() ) {
			this.close();
			return;
		}
		this.open();
	};
	Accordion.prototype.open = function() {
		if ( this.on_before_open ) {
			this.on_before_open( this );
		}
		this.element.classList.add( 'accordion__item--open' );
		this.accordionContent.style.height = this.accordionContentInner.offsetHeight + 'px';
	};
	Accordion.prototype.close = function() {
		this.element.classList.remove( 'accordion__item--open' );
		this.accordionContent.style.height = 0;
	};

	const accordion_triggers = document.querySelectorAll( '.accordion__item__button' );
	const accordions = [];
	function closeAllAccordions() {
		for ( let i = 0; i < accordions.length; i += 1 ) {
			accordions[i].close();
		}
	}
	function onBeforeAccordionOpen( ) {
		closeAllAccordions();
	}
	function handleAccordionToggle( accordion ) {
		return function() {
			accordion.toggle();
		};
	}
	for ( let i = 0; i < accordion_triggers.length; i += 1 ) {
		const accordion = new Accordion( accordion_triggers[i], onBeforeAccordionOpen );
		accordions.push( accordion );
		accordion_triggers[i].addEventListener( 'click', handleAccordionToggle( accordion ) );
	}
	closeAllAccordions();
} )();

( function() {
	// Smooth Scroll
	function handleSmoothAnchorClick( anchor ) {
		const target_id = anchor.href.split( '#' )[1];
		const target = document.getElementById( target_id );
		return function( event ) {
			event.preventDefault();
			const target_y = getOffsetTop( target );
			smoothScroll.scroll( target_y - 54, 1000 );
		};
	}
	const anchors = document.querySelectorAll( '.js-smooth-anchor' );
	for ( let i = 0; i < anchors.length; i += 1 ) {
		anchors[i].addEventListener( 'click', handleSmoothAnchorClick( anchors[i] ) );
	}
} )();

//[1,2,3].map(n => n + 1);

( function() {
	// Slideshows with pips
	// Requires `data-pips-container-id` on your slideshow element.
	function makeSlideshow( element ) {
		const slideshow = new Ten4Slideshow( element );
		const slide_interval = parseInt( element.getAttribute( 'data-slide-interval' ), 10 );
		const slideshow_pips_container = document.getElementById( element.getAttribute( 'data-pips-container-id' ) );
		const slideshow_pips = slideshow_pips_container.querySelectorAll( '.slideshow__pip' );
		let timer_id = null;
		slideshow_pips[0].classList.add( 'slideshow__pip--selected' );
		slideshow.addCallback( ( index ) => {
			for ( let i = 0; i < slideshow_pips.length; i += 1 ) {
				if ( i === index ) {
					slideshow_pips[i].classList.add( 'slideshow__pip--selected' );
					continue;
				}
				slideshow_pips[i].classList.remove( 'slideshow__pip--selected' );
			}
		} );
		function resetInterval() {
			window.clearInterval( timer_id );
			timer_id = window.setInterval( () => {
				slideshow.slide();
			}, slide_interval );
		}
		function handlePipClick( index ) {
			return function() {
				resetInterval();
				slideshow.slideTo( index );
			};
		}
		for ( let i = 0; i < slideshow_pips.length; i += 1 ) {
			slideshow_pips[i].addEventListener( 'click', handlePipClick( i ) );
		}
		resetInterval();
	}
	const slideshows = document.querySelectorAll( '.slideshow' );
	for ( let i = 0; i < slideshows.length; i += 1 ) {
		makeSlideshow( slideshows[i] );
	}

} )();

( function() {
	// Height match columns

	// var window_width = document.documentElement.clientWidth || document.body.clientWidth;
	// if ( window_width <= 770 ) {
	// 	return;
	// }

	function resetElementHeights( elements ) {
		for ( let i = 0; i < elements.length; i += 1 ) {
			elements[i].style.height = 'auto';
		}
	}

	function getShortestElement( elements ) {
		let shortest = elements[0];
		for ( let i = 1; i < elements.length; i += 1 ) {
			if ( elements[i].offsetHeight < shortest.offsetHeight ) {
				shortest = elements[i];
			}
		}
		return shortest;
	}

	const elements = document.querySelectorAll( '.heightmatch' );
	const bins = {};
	let bin_id;

	function heightmatchBin( bin_id ) {
		resetElementHeights( bins[bin_id] );
		const shortest = getShortestElement( bins[bin_id] );
		for ( let i = 0; i < bins[bin_id].length; i += 1 ) {
			bins[bin_id][i].style.height = shortest.offsetHeight + 'px';
		}
	}

	function heightmatchAllBins() {
		for ( const bin_id in bins ) {
			if ( !Object.prototype.hasOwnProperty.call( bins, bin_id ) ) {
				continue;
			}
			heightmatchBin( bin_id );
		}
	}

	for ( let i = 0; i < elements.length; i += 1 ) {
		bin_id = elements[i].getAttribute( 'data-heightmatch-bin' );
		if ( !Object.prototype.hasOwnProperty.call( bins, bin_id ) ) {
			bins[bin_id] = [];
		}
		bins[bin_id].push( elements[i] );
	}

	// Not ideal to heightmatch multiple times, after each individual
	// image loads, but I found it was the best way to avoid weird loading
	// issues.
	const screen_width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if ( screen_width > 700 ) {
		const body_image_load = imagesLoaded( document.body );
		body_image_load.on( 'progress', () => {
			heightmatchAllBins();
		} );
	}

} )();

( function() {
	// Async feeds
	function handleAjaxSuccess( feed_container ) {
		return function( data ) {
			feed_container.classList.add( 'external-feed--loaded' );
			feed_container.innerHTML = data;
		};
	}

	function handleAjaxError( feed_container ) {
		return function() {
			feed_container.classList.add( 'external-feed--loaded' );
			feed_container.innerHTML = '<p class="p">Feed failed to load.</p>';
		};
	}

	const feed_containers = document.querySelectorAll( '.external-feed' );
	for ( let i = 0; i < feed_containers.length; i += 1 ) {
		const url = feed_containers[i].getAttribute( 'data-feed-url' );
		if ( !url ) {
			continue;
		}
		ajax( {
			type: 'get',
			url: url,
			timeout: 8000,
			onSuccess: handleAjaxSuccess( feed_containers[i] ),
			onError: handleAjaxError( feed_containers[i] )
		} );
	}

} )();

( function() {
	// Project detail/info toggle
	function getTallestToggle( toggles ) {
		let tallest = toggles[0];
		for ( let i = 1; i < toggles.length; i += 1 ) {
			if ( toggles[i].clientHeight > tallest.clientHeight ) {
				tallest = toggles[i];
			}
		}
		return tallest;
	}
	const info_toggler = document.getElementById( 'js-info-toggler' );
	const intro_toggler = document.getElementById( 'js-intro-toggler' );
	const toggles_container = document.querySelector( '.toggles' );
	const toggles = document.querySelectorAll( '.toggle-content' );

	const intro_div = document.getElementById( 'js-project-intro' );
	const info_div = document.getElementById( 'js-project-info' );

	if ( toggles_container ) {
		const tallest_toggle = getTallestToggle( toggles );
		toggles_container.style.height = tallest_toggle.clientHeight + 'px';

		window.addEventListener( 'load', () => {
			const tallest_toggle = getTallestToggle( toggles );
			toggles_container.style.height = tallest_toggle.clientHeight + 'px';
		} ) ;

		info_toggler.addEventListener( 'click', ( event ) => {
			event.preventDefault ? event.preventDefault() : event.returnValue = false;
			if ( info_div.classList.contains( 'is-hidden' ) ) {
				intro_div.classList.add( 'is-hidden' );
				intro_div.classList.add( 'is-hidden--ie8' );
				info_div.classList.remove( 'is-hidden' );
				info_div.classList.remove( 'is-hidden--ie8' );
			} else {
				info_div.classList.add( 'is-hidden' );
				info_div.classList.add( 'is-hidden--ie8' );
				intro_div.classList.remove( 'is-hidden' );
				intro_div.classList.remove( 'is-hidden--ie8' );
			}
		} );

		intro_toggler.addEventListener( 'click', ( event ) => {
			event.preventDefault ? event.preventDefault() : event.returnValue = false;
			if ( intro_div.classList.contains( 'is-hidden' ) ) {
				info_div.classList.add( 'is-hidden' );
				info_div.classList.add( 'is-hidden--ie8' );
				intro_div.classList.remove( 'is-hidden' );
				intro_div.classList.remove( 'is-hidden--ie8' );
			} else {
				intro_div.classList.add( 'is-hidden' );
				intro_div.classList.add( 'is-hidden--ie8' );
				info_div.classList.remove( 'is-hidden' );
				info_div.classList.remove( 'is-hidden--ie8' );
			}
		} );

	}
} )();

( () => {

	// Compare Slider

	const compare_sliders = document.querySelectorAll( '.compare-slider' );

	if ( !compare_sliders.length > 0 ) {
		return;
	}

	compare_sliders.forEach( compare_slider => {
		document.querySelector( '.compare-slider__input' ).addEventListener( 'input', ( e ) => {
			compare_slider.style.setProperty( '--position', `${e.target.value}%` );
		} );
	} );

} )();

( () => {
// Filters
	const filter_form = document.getElementById( 'js-filters' );
	const results_container = document.getElementById( 'js-filter-results' );
	if ( !filter_form || !results_container ) {
		return;
	}

	const pagination_container = document.getElementById( 'pagination' );
	const filter_container = document.querySelector( '.filter-section' );
	const filter_highlights = document.getElementById( 'js-highlight-filters' );
	const filter_toggle = document.querySelector( '.filter-toggle' );

	window.addEventListener( 'change', ( e ) => {
		if ( e.target.classList.contains( 'filter__checkbox-input' ) ) {
			filterFormQuery( e.target.closest( '#js-filters' ) );
		}
	} );

	window.addEventListener( 'click', ( e ) => {
		if ( e.target.classList.contains( 'filter__clear' ) ) {
			const form = e.target.closest( '#js-filters' );
			if ( form && form.tagName === 'FORM' ) {
				form.querySelectorAll( 'input' ).forEach( field => {
					if ( field.type === 'checkbox' ) {
						field.checked = false;
					}
				} );
				requestAnimationFrame( () => filterFormQuery( form ) );
			}
		}
	} );

	window.addEventListener( 'submit', ( e ) => {
		if ( e.target.getAttribute( 'id' ) === 'js-filters' ) {
			e.preventDefault();
			document.body.classList.remove( 'filter-open' );
			filter_container.classList.remove( 'visible' );
		}
	} );

	async function filterFormQuery( form ) {
		const all_params = new URLSearchParams( window.location.search );
		const form_data = new FormData( form );
		// for ( const pair of form_data.entries() ) {
		// 	console.log( pair[0], pair[1] );
		// }

		const search_params = new URLSearchParams( form_data );
		// Remove existing keys that are no longer present in the form data
		for ( const key of [...all_params.keys()] ) {
			if ( !search_params.has( key ) ) {
				all_params.delete( key );
			}
		}
		// Clear previous values for each key and then add the new ones
		for ( const key of search_params.keys() ) {
			all_params.delete( key );
			search_params.getAll( key ).forEach( ( value ) => {
				all_params.append( key, value );
			} );
		}
		// Final cleanup: remove empty keys
		for ( const key of [...all_params.keys()] ) {
			if ( !all_params.getAll( key ).length ) {
				all_params.delete( key );
			}
		}

		const query_string = all_params.toString();
		const url = `${window.location.pathname}?${query_string}`;
		// Update URL without reloading
		window.history.pushState( null, null, decodeURI( url ) );
		// Fetch filtered results asynchronously
		await sendFilteredContent( url );
	}

	async function sendFilteredContent( url ) {
		try {
			const response = await fetch( url, {
				method: 'GET',
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				}
			} );

			if ( !response.ok ) {
				throw new Error( `HTTP error! Status: ${response.status}` );
			}

			const response_text = await response.text();
			updateFilteredContent( response_text );
		} catch ( error ) {
			// eslint-disable-next-line
			console.error( 'Error fetching filtered content:', error );
			results_container.innerHTML = '<p>Sorry, unable to load results.</p>';
		}
	}

	function updateFilteredContent( responseText ) {
		results_container.innerHTML = '';
		if ( filter_highlights ) {
			filter_highlights.innerHTML = '';
		}
		if ( pagination_container ) {
			pagination_container.innerHTML = '';
		}

		const parser = new DOMParser();
		const new_results_container = parser.parseFromString( responseText, 'text/html' );

		const new_results_content = new_results_container.getElementById( 'js-filter-results' );
		const new_pagination_content = new_results_container.getElementById( 'pagination' );
		const new_highlight_filter_content = new_results_container.getElementById( 'js-highlight-filters' );
		const new_filter_container = new_results_container.querySelector( '.filter-section' );
		const new_filter_toggle = new_results_container.querySelector( '.filter-toggle' );

		if ( new_results_content ) {
			results_container.innerHTML = new_results_content.innerHTML;
			if ( pagination_container && new_pagination_content ) {
				pagination_container.innerHTML = new_pagination_content.innerHTML;
			}
			if ( filter_container && new_filter_container ) {
				filter_container.innerHTML = new_filter_container.innerHTML;
			}
			if ( filter_highlights && new_highlight_filter_content ) {
				filter_highlights.innerHTML = new_highlight_filter_content.innerHTML;
			}
			if ( filter_toggle && new_filter_toggle ) {
				filter_toggle.innerHTML = new_filter_toggle.innerHTML;
			}
		} else {
			results_container.innerHTML = '<p>Sorry, unable to load results.</p>';
		}
	}
} )();

( () => {
	// Autoscrolling slideshow
	const carousels = document.querySelectorAll( '.carousel' );
	if ( !carousels ) {
		return;
	}

	carousels.forEach( carousel => {
		const viewport_node = carousel.querySelector( '.carousel__viewport' );
		const options = {
			loop: true,
		};

		if ( carousel.classList.contains( 'carousel--autoplay' ) ) {
			const embla_api = EmblaCarousel( viewport_node, options, [
				AutoScroll(),
			] );
		} else {
			const prev = carousel.querySelector( '.carousel__button--prev' );
			const next = carousel.querySelector( '.carousel__button--next' );
			const embla_api = EmblaCarousel( viewport_node, { loop: false, containScroll: false, align: 'center' }, [Fade()] );
			const dots_node = carousel.querySelector( '.carousel__pips' );
			if ( next && prev ) {
				const remove_prev_next_click_handlers = addPrevNextBtnsClickHandlers( embla_api, prev, next );
				const remove_toggle_prev_next_active = addTogglePrevNextBtnsActive( embla_api, prev, next );
				const remove_dots_btns_and_click_handlers = add_dot_btns_and_click_handlers( embla_api, dots_node );
				embla_api
					.on( 'destroy', remove_prev_next_click_handlers )
					.on( 'destroy', remove_toggle_prev_next_active )
					.on( 'destroy', remove_dots_btns_and_click_handlers );
			}
		}
	} );
} )();

( () => {
	// Manual Carousel
	const carousels = document.querySelectorAll( '.featured-carousel' );

	carousels.forEach( ( carousel_el ) => {
		const viewport = carousel_el.querySelector( '.featured-carousel__viewport' );
		const prev_btn = carousel_el.querySelector( '.scrollLeft' );
		const next_btn = carousel_el.querySelector( '.scrollRight' );
		const indicator = carousel_el.querySelector( '.featured-carousel__indicator' );

		if ( !viewport || !prev_btn || !next_btn || !indicator ) {
			return;
		}

		const embla = EmblaCarousel( viewport, {
			loop: false,
			align: 'start',
			containScroll: false,
			slidesToScroll: 1
		} );

		const update_slide_indicator = () => {
			const current_index = embla.selectedScrollSnap() + 1;
			const total_slides = embla.slideNodes().length;
			indicator.textContent = `${current_index} / ${total_slides}`;
		};

		const toggle_buttons = () => {
			prev_btn.disabled = !embla.canScrollPrev();
			next_btn.disabled = !embla.canScrollNext();
		};

		embla.on( 'select', () => {
			update_slide_indicator();
			toggle_buttons();
		} );

		embla.on( 'init', () => {
			update_slide_indicator();
			toggle_buttons();
		} );

		prev_btn.addEventListener( 'click', () => embla.scrollPrev() );
		next_btn.addEventListener( 'click', () => embla.scrollNext() );
	} );
} )();

( () => {
	document.addEventListener( 'DOMContentLoaded', () => {
		const refresh_button = document.getElementById( 'refresh-cards' );
		const container = document.querySelector( '[data-random-people]' );

		if ( refresh_button && container ) {
			refresh_button.addEventListener( 'click', () => {
				fetch( window.location.pathname, {
					headers: { 'X-Requested-With': 'XMLHttpRequest' }
				} )
					.then( res => res.text() )
					.then( html => {
						container.innerHTML = html;
					} );
			} );
		}
	} );
} )();